<div class="container px-4 pb-4">
  <app-shared-action-bar [displayActionSectionBar]="showActionSectionBar" (undoRequest)="resetUser()"
    (saveRequest)="validateUser()" [saveReady]="unsavedChanges"
  [undoReady]="unsavedChanges"></app-shared-action-bar>
  <div class="mt-20">
    <div class="pb-4 mx-4">
      @if (!isGroup) {
        <h2 class="settings-header">New User</h2>
      }
      @if (isGroup) {
        <h2 class="settings-header">New Group</h2>
      }
    </div>


    @if (noLicense) {
      <div class="mx-8 mt-8 border-solid border-grey-900 border-2 rounded-md p-4 inline-block">
        @if (noLicense) {
          <p class="text-green-700 text-lg">No available user licenses, please contact your account
          manager.</p>
        }
      </div>
    }

    @if (!noLicense) {
      <div class="mx-4 ">
        <div class="xl:w-3/5 lg:w-4/5">
          @if (!isGroup) {
            <div class="mb-4">
              <label class="mr-2">Username</label>
              <input type="text" class="text-box" [(ngModel)]="newUser.Username" (ngModelChange)="resetFlags()"
                (keyup)="checkForChange()" />
                @if (invalidUserName) {
                  <p class="text-danger-base">Username is invalid</p>
                }
                @if (isUsernameInUse) {
                  <p class="text-danger-base">Username must be unique, please select a different
                  username</p>
                }
              </div>
            }
            <div class="mb-4">
              @if (!isGroup) {
                <label class="mr-2">Display Name</label>
              }
              @if (isGroup) {
                <label class="mr-2">Group Name</label>
              }
              <input type="text" class="text-box" [(ngModel)]="newUser.DisplayName" (ngModelChange)="resetFlags()"
                (keyup)="checkForChange()" />
                @if (invalidDisplayName) {
                  <p class="text-danger-base">Display Name is not valid</p>
                }
              </div>
              @if (!isGroup) {
                <div class="mb-8">
                  <label class="mr-2">Email</label>
                  <input type="email" class="text-box" [(ngModel)]="newUser.Email" (ngModelChange)="resetFlags()"
                    (keyup)="checkForChange()" />
                    @if (invalidEmail) {
                      <p class="text-danger-base">Email is invalid</p>
                    }
                    @if (emailUsed) {
                      <p class="text-danger-base">Email is already assigned to an account</p>
                    }
                  </div>
                }
                <div class="mb-6 py-4 px-2 border-solid border-y-2 border-grey-300">
                  <div class="flex justify-between">
                    <label class="mr-2">Daily Reminders</label>
                    <app-toggle-switch [(checked)]="newUser.DailyReminders"></app-toggle-switch>
                  </div>
                  <div class="flex justify-between mt-4">
                    <label class="mr-2">Weekly Summary</label>
                    <app-toggle-switch [(checked)]="newUser.WeeklySummary"></app-toggle-switch>
                  </div>
                  @if (!isGroup) {
                    <div class="flex justify-between mt-4">
                      <label class="mr-2">Daily Recaps</label>
                      <app-toggle-switch [(checked)]="newUser.SendDailyRecaps"></app-toggle-switch>
                    </div>
                    <div class="flex justify-between mt-4">
                      <label class="mr-2">Action Emails</label>
                      <app-toggle-switch [(checked)]="newUser.SendActionEmails"></app-toggle-switch>
                    </div>
                  }
                </div>
              </div>

          </div>
        }
      </div>
